
import { formatPrice } from "@/utils/serviceUtils";

interface ServicePriceDisplayProps {
  servicePrice: number;
  originalPrice?: number;
  travelFee?: number | null;
  hasTravelFee: boolean;
  currency?: string | null;
}

export const ServicePriceDisplay = ({
  servicePrice,
  originalPrice,
  travelFee = 0,
  hasTravelFee,
  currency
}: ServicePriceDisplayProps) => {
  // Calculate total price - ALWAYS add travel fee if applicable
  const totalPrice = hasTravelFee 
    ? servicePrice + (travelFee || 0) 
    : servicePrice;

  return (
    <>
      {/* ALWAYS display the total price (including travel fee) prominently */}
      <p className="text-gebeya-pink font-medium">
        {formatPrice(totalPrice, null, currency)}
      </p>
      
      {/* Show detailed breakdown if there's a travel fee */}
      {hasTravelFee && (
        <div className="text-sm text-gray-600 mt-1">
          <div className="flex justify-between">
            <span>Service fee:</span>
            <span>{formatPrice(servicePrice, null, currency)}</span>
          </div>
          <div className="flex justify-between">
            <span>Travel fee:</span>
            <span>{formatPrice(travelFee || 0, null, currency)}</span>
          </div>
        </div>
      )}
      
      {/* If there's a discount but no travel fee, show the original price */}
      {!hasTravelFee && originalPrice && originalPrice > servicePrice && (
        <div className="text-sm text-gray-500">
          <span className="line-through">{formatPrice(originalPrice, null, currency)}</span>
          <span className="ml-1 text-xs bg-green-100 text-green-800 px-1 py-0.5 rounded-full">
            {Math.round((1 - (servicePrice / originalPrice)) * 100)}% OFF
          </span>
        </div>
      )}
    </>
  );
};
